import { startMeasure, stopMeasure } from '@atlaskit/editor-common/utils';
import { getParticipantsCount } from '../plugins/collab-edit/get-participants-count';
import { analyticsPluginKey } from '../plugins/analytics/plugin-key';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '../plugins/analytics'; // This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type

export let nodeViewRenderedEventsCounter = 0;
const DEFAULT_SAMPLING_RATE = 100;
const DEFAULT_SLOW_THRESHOLD = 7;
export function getPerformanceOptions(view) {
  const pluginState = analyticsPluginKey.getState(view.state);
  const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
  const samplingRate = nodeViewTracking.samplingRate || DEFAULT_SAMPLING_RATE;
  const slowThreshold = nodeViewTracking.slowThreshold || DEFAULT_SLOW_THRESHOLD;
  return {
    trackingEnabled: !!nodeViewTracking.enabled,
    samplingRate,
    slowThreshold
  };
}
export function startMeasureReactNodeViewRendered({
  nodeTypeName
}) {
  startMeasure(`🦉${nodeTypeName}::ReactNodeView`);
}
export function stopMeasureReactNodeViewRendered({
  nodeTypeName,
  dispatchAnalyticsEvent,
  editorState,
  samplingRate,
  slowThreshold
}) {
  stopMeasure(`🦉${nodeTypeName}::ReactNodeView`, duration => {
    if (++nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) {
      dispatchAnalyticsEvent({
        action: ACTION.REACT_NODEVIEW_RENDERED,
        actionSubject: ACTION_SUBJECT.EDITOR,
        eventType: EVENT_TYPE.OPERATIONAL,
        attributes: {
          node: nodeTypeName,
          duration,
          participants: getParticipantsCount(editorState)
        }
      });
    }
  });
}